//GEO

import moment from "moment";
import { ColorManager } from "./colormanager";

export class GeoPoint {
  id; //:number|undefined;
  name; //:String|undefined;
  geoX; //:number|undefined;
  geoY; //:number|undefined;
}

export class Place {
  city; //:string|undefined;
  country; //:string|undefined;
  name; //:string|undefined;
  postCode; //:string|undefined;
  street; //:string|undefined;
  street2; //:string|undefined;
}

export class Booking {
  id; //:number;
  tour; //:string | undefined;
  resource; //:string | undefined;
  sortOrder; //:number | undefined;
  serviceTypeId; //:number | undefined;
  noOfItems; //:number|undefined;
  name; //:string|undefined;
  description; //:string|undefined;

  pickup;
  delivery;
}

export class MissingGeo {
  constructor(place, bookings) {
    this.place = place;
    this.bookings = bookings;
  }

  place;
  bookings;
}

export class Tour {
  id;
  name;
  routes;
  expanded;
}

export class PlanManager {
  constructor(settings, api) {
    this.basicSettings = settings;
    this.api = api; //Get Api from consumer
    this.cmgr = new ColorManager();

    this.geoCodeDefaultStops();
    //this.geoGetRouteSettingsLogic();
  }

  Plan = class {
    constructor(period, name) {
      this.period = period;
      this.name = name;
      this.routes = [];
      this.bookings = [];
      this.tours = [];
    }
  };

  uniqueId = -1;
  plan;
  api;
  cmgr;

  geoCodeDefaultStops() {
    this.api.get("/api/geo/GetDefaultPlaces").then((res) => {
      this.basicSettings.places = res.data;
      this.basicSettings.places.map((x) => {
        var p = this.api.params(x);
        this.api.get("/api/geo/GetGeoPlace?" + p).then((res) => {
          x.geo = {
            id: res.data.Id,
            geoX: res.data.GeoX,
            geoY: res.data.GeoY,
            name: res.data.Street,
            text: res.data.Street,
          };
        });
      });
      if (this.basicSettings.places.length == 0) {
        alert(
          "Gick inte att hämta standardplatser från servern. Vänligen prova igen.",
        );
        return;
      }
      var defPlace = this.basicSettings.places.find(
        (x) => x.id == this.basicSettings.route.defaultStartPlaceId,
      );
      if (!defPlace) {
        this.basicSettings.route.defaultStartPlaceId = this.basicSettings.places[0].id;
      }
    });
  }

  // geoGetRouteSettingsLogic() {
  //     this.api.get('/api/geo/GetSettingsLogic').then(res => {
  //         this.basicSettings.routeSettings = res.data.routeSettingsItems;
  //         this.basicSettings.routeSettings.sort((a, b) => {
  //             const sortA = (a.tourName ? 2 : 0) + (a.terminalName ? 1 : 0);
  //             const sortB = (b.tourName ? 2 : 0) + (b.terminalName ? 1 : 0);
  //             return sortB - sortA;
  //             });
  //         var defVal = this.basicSettings.routeSettings.find(x => x.tourName == null && x.terminalName == null);

  //         this.basicSetttings.params = {
  //             stopConsolidate_maxGeoX: '0.01',
  //             stopConsolidate_maxGeoY: '0.01',
  //             stopConsolidate_sameGeoId: '0',
  //         }; //Set default params
  //         res.data.planSettingsItems.map(x => {
  //             this.basicSettings.params[x.keyName] = x.value;
  //         });

  //     });
  // }

  geoGetRouteSettingsLogicForTour(tourName) {
    var val = this.basicSettings.routeSettings.find(
      (x) => x.tourName == tourName,
    );
    if (!val)
      val = this.basicSettings.routeSettings.find(
        (x) => x.tourName == null && x.terminalName == null,
      );
    return val;
  }

  addBookingToPlan(booking) {
    //Lägg till bokning till plan
    var b = this.plan.bookings.find((x) => x.id == booking.id);
    if (!b) {
      b = booking;
      this.plan.bookings.push(b);
      var r = this.getOrAddRoute(b.tour, b.resource, b.terminalName);
      this.addBookingToRoute(r, b);
    } else {
      this.updateBookingInRoute(b, r);
    }
  }

  addBookingToRoute(route, booking) {
    var b = route.bookings.find((x) => x.id == booking.id);
    if (!b) {
      b = booking;
      route.bookings.push(b);
      this.pushAction(route, b.pickup, { type: "PU", booking: b });
      this.pushAction(route, b.delivery, { type: "DLV", booking: b });

      this.routeSetDirty(route);
    }
  }

  routeRefreshMissingGeos(route) {
    var missing = [];
    route.bookings.map((b) => {
      if (this.isMissing(b.pickup))
        this.addPlaceToMissingGeos(missing, b.pickup, b.id);
      if (this.isMissing(b.delivery))
        this.addPlaceToMissingGeos(missing, b.delivery, b.id);
    });
    route.missingGeos = missing;
    this.routeSetDirty(route); //Check if change? Kanske kan bli rundgång...
  }
  addPlaceToMissingGeos(missingGeos, place, bId) {
    var pjson = JSON.stringify(pjson);
    var m = missingGeos.find((x) => JSON.stringify(x.place) == pjson);
    if (!m) missingGeos.push((m = { place: place, bookingsIds: [] }));
    m.bookingsIds.push(bId);
  }

  isMissing(place) {
    return !(place && place.geo && place.geo.geoX && place.geo.geoY);
  }

  pushAction(route, place, action) {
    var stops = route.stops;
    if (!place || !place.geo)
      //Missing geo
      return false;

    let minIdx = 0;
    if (action.type == "DLV") {
      //TODO://Must check if PICKUP is before
      var puIdx = stops.findIndex(
        (s) =>
          s.actions.findIndex(
            (a) => a.booking.id == action.booking.id && a.type == "PU",
          ) >= 0,
      );
      if (puIdx > 0) minIdx = puIdx + 1; //Cannot be same stop
    }
    //Check for stops with same geoId
    var currStop = null;
    for (var currIdx = minIdx; currIdx < stops.length && !currStop; currIdx++) {
      var s = stops[currIdx];
      // if (s.place && s.place.geo && s.place.geo.id == place.geo.id)
      //     currStop = s;
      if (s.place && s.place.geo && this.isSameGeo(s.place.geo, place.geo))
        currStop = s;
    }

    if (!currStop) {
      currStop = {
        //sortOrder: 2, //Default sortorder, between
        locked: false,
        text: `${place.street},${place.city}`,
        place: place,
        actions: [],
        sortOrder: stops.length,
        stopId: this.getUniqueId(),
      }; //New stop
      stops.splice(stops.length - 1, 0, currStop); //Add just before end of route
    }
    currStop.actions.push(action);

    return true;
  }

  isSameGeo(g1, g2) {
    //This defined the logic how to cluster bookings (places) into same stop
    const maxDx = this.basicSettings.params.stopConsolidate_maxGeoX
      ? parseFloat(this.basicSettings.params.stopConsolidate_maxGeoX)
      : 0.01;

    const maxDy = this.basicSettings.params.stopConsolidate_maxGeoY
      ? parseFloat(this.basicSettings.params.stopConsolidate_maxGeoY)
      : 0.01;

    const sameGeoId =
      this.basicSettings.params.stopConsolidate_sameGeoId === "1"; //console.log('isSameGeo', g1, g2, maxDx, maxDy, sameGeoId);

    if (!(g1 && g2)) return false;

    //TEST- OBS! Massor...
    //         console.log("maxDx:", maxDx, typeof maxDx);
    // console.log("maxDy:", maxDy, typeof maxDy);
    // console.log("sameGeoId:", sameGeoId, typeof sameGeoId);

    if (sameGeoId && g1.id != g2.id) return false;

    if (Math.abs(g1.geoX - g2.geoX) > maxDx) return false;
    if (Math.abs(g1.geoY - g2.geoY) > maxDy) return false;

    return true;
  }

  routeSetDirty(route) {
    route.dirty = true;

    //Recalc MissingGeos
  }

  getOrAddRoute(tour, resource, terminalName) {
    //terminalName is optional, used when creating new route
    var r = this.plan.routes.find(
      (x) => x.tourName == tour && x.resource == resource,
    );
    if (!r) r = this.createEmptyRoute(tour, resource, terminalName);

    return r;
  }

  createEmptyRoute(tour, resource, terminalName) {
    //Template of new Route
    var r = {
      id: this.getUniqueId(),
      name: resource,
      bookings: [],
      tourName: tour,
      resource: resource,
      stops: [],
      kpis: null, //Should it be an array with key-values instead?
      selected: false,
      geometry: null,
      color: this.cmgr.GetNextColor(),
    };

    this.plan.routes.push(r);

    r.defaultStartPlaceId = this.basicSettings.route.defaultStartPlaceId;
    if (terminalName) {
      //Find terminal place by name
      var f = this.basicSettings.places.find(
        (x) => x.terminalName.toLowerCase() == terminalName.toLowerCase(),
      );
      if (f) r.defaultStartPlaceId = f.id;
    }

    r.stops.push(this.createDefaultStop(r.defaultStartPlaceId, 1));
    r.stops.push(this.createDefaultStop(r.defaultStartPlaceId, 99999));

    return r;
  }

  changeTerminalForRoute(route, placeId) {
    //Change terminal for route
    var f = this.basicSettings.places.find((x) => x.id == placeId);
    if (f) {
      var oldPlace = route.stops[0].place;
      if (oldPlace && oldPlace.id == placeId)
        //Same place, do nothing
        return;
      var stps = route.stops.filter(
        (x) => x.place && x.place.id == oldPlace.id,
      );
      stps.map((x) => {
        x.place = f;
        x.text = "TERMINAL:" + f.terminalName; //'TERMINAL';
      });
      route.dirty = true;
      this.CalcRouteDriveForRoute(route, true);
    }
  }

  createDefaultStop(placeId, sortOrder) {
    var f = this.basicSettings.places.find((x) => x.id == placeId);
    if (f)
      return {
        sortOrder: sortOrder,
        locked: true,
        text: "TERMINAL:" + f.terminalName, //'TERMINAL',
        place: { ...f },
        stopId: this.getUniqueId(),
        actions: [], // {type:'PU/DLV', booking: {...}}
      }; //New stop
  }

  refreshPlan() {
    this.plan.routes.filter((x) => x.dirty).map((x) => this.refreshRoute(x));
    this.refreshTours();
  }

  refreshTours() {
    this.plan.routes.map((r) => {
      var t = this.plan.tours.find((x) => x.name == r.tourName);
      if (!t) {
        // t = { id: this.uniqueId++, name: r.tourName, routes: [], expanded: false };
        // this.plan.tours.push(t);
        t = this.addTour(r.tourName);
      }
      if (t.routes.findIndex((x) => x.resource == r.resource) < 0)
        t.routes.push(r);
    });
  }
  addTour(tourName) {
    var t = {
      id: this.uniqueId++,
      name: tourName,
      routes: [],
      expanded: false,
    };
    this.plan.tours.push(t);

    return t;
  }

  refreshRoute(r) {
    //Do some refresh
    this.routeRefreshMissingGeos(r);
    if (r.missingGeos.length == 0) this.CalcRouteDriveForRoute(r, true);

    this.recalcKpisForRoute(r);

    r.dirty = false;
  }

  kpi_parameters = {
    workMinutesPerStop: 10,
    workMinutesPerBooking: 1,
    workMinutesPerColli: 1,

    costPerHour: 450,
    costPerKm: 5,
    costPerRoute: 200,
  };

  recalcKpisForRoute(r) {
    var conf = this.geoGetRouteSettingsLogicForTour(r.tourName);

    if (!r.kpi)
      r.kpi = {
        stopCount: 0,
        bookingsCount: 0,
        collisCount: 0,
        kms: 0,
        workMinutes: 0,
        driverMinutes: 0,
        totMinutes: 0,
        cost: 0,
      };
    var kpi = r.kpi;

    r.stops.map((s) => this.recalcKpisForStop(s, r, conf));
    // kpi.driverMinutes = 0;
    // r.stops.map(s => kpi.driverMinutes += s.kpi.driverMinutes);
    kpi.workMinutes = 0;
    r.stops.map((s) => (kpi.workMinutes += s.kpi.workMinutes));

    //Refresh arrival times
    var tm = 0; //Route start time?
    if (!r.startTime && conf.defaultStartTime) {
      r.startTime = conf.defaultStartTime;
    }

    r.stops.map((x) => {
      //driverMinutes can be null
      //driverMinutes is minutes from previous stop
      tm += x.kpi.driverMinutes ? x.kpi.driverMinutes : 0;
      x.arrivalTime = tm;
      if (r.startTime)
        x.arrivalTimeStr = moment(r.startTime, "HH:mm")
          .add(x.arrivalTime, "minutes")
          .format("HH:mm");
      tm += x.kpi.workMinutes;
      x.departureTime = tm;
    });
    kpi.stopCount = r.stops.length - 2; //Include start/stop?
    kpi.bookingsCount = r.bookings.length;
    kpi.collisCount = 0;
    r.bookings.map((x) => (kpi.collisCount += x.noOfItems));

    this.refreshKpisCalculation(conf, kpi);

    r.kpis = kpi;
  }

  recalcKpisForStop(s, r, conf) {
    if (!s.kpi) s.kpi = { manWorkMinutes: null };
    s.kpi.stopCount = 1; //s.actions.length;
    var bs = r.bookings.filter(
      (b) => s.actions.findIndex((a) => a.booking.id == b.id) >= 0,
    );
    s.kpi.bookingsCount = bs.length;
    s.kpi.collisCount = 0;
    bs.map((x) => (s.kpi.collisCount += x.noOfItems));
    s.kpi.calcMinutes = s.locked
      ? 1
      : this.getDefaultWorkMinutes(
          conf,
          s.kpi.stopCount,
          s.kpi.bookingsCount,
          s.kpi.collisCount,
        );
    s.kpi.workMinutes = s.kpi.manWorkMinutes
      ? s.kpi.manWorkMinutes
      : s.kpi.calcMinutes;
  }
  getDefaultWorkMinutes(conf, stopCount, bookingsCount, collisCount) {
    // var wt =
    //     stopCount * this.kpi_parameters.workMinutesPerStop +
    //     bookingsCount * this.kpi_parameters.workMinutesPerBooking +
    //     collisCount * this.kpi_parameters.workMinutesPerColli;
    var wt =
      stopCount * conf.workMinutesPerStop +
      bookingsCount * conf.workMinutesPerBooking +
      collisCount * conf.workMinutesPerColli;

    return wt;
  }

  refreshKpisCalculation(conf, kpi) {
    // kpi.workMinutes =
    //     kpi.stopCount * this.kpi_parameters.workMinutesPerStop +
    //     kpi.bookingsCount * this.kpi_parameters.workMinutesPerBooking +
    //     kpi.collisCount * this.kpi_parameters.workMinutesPerColli;
    kpi.totMinutes = kpi.driverMinutes + kpi.workMinutes;
    kpi.cost = Math.round(
      (kpi.totMinutes / 60) * conf.costPerHour + //this.kpi_parameters.costPerHour
        kpi.kms * conf.costPerKm,
    );
    if (kpi.stopCount > 2) kpi.cost += conf.costPerRoute;
  }

  setStopWorkTime(r, s, v) {
    s.kpi.manWorkMinutes = v;
    this.recalcKpisForRoute(r);
  }

  updateBookingInRoute(route, booking) {
    //Sätter dirty om bokningen finns
    if (route.bookings.findIndex((x) => x.id == booking.id) >= 0)
      route.dirty = true;
  }

  CalcRouteDriveForRoute(r, force) {
    console.log("CalcRouteDriveForRoute");
    if (r.geometry && !force)
      //Already calculated
      return;
    var places = r.stops.map((s) => s.place);
    if (places.length <= 2) {
      r.kpi.kms = 0;
      r.kpi.driverMinutes = 0;
      r.geometry = [];
      var conf = this.geoGetRouteSettingsLogicForTour(r.tourName);
      this.refreshKpisCalculation(conf, r.kpis);
    } else {
      //exclude start and stop
      this.api.post("/api/geo/GetRoute", places).then((res) => {
        console.log(res.data);

        //Move this to server side
        if (res.data && res.data.routes.length > 0) {
          var calc = res.data.routes[0];
          r.kpis.kms = Math.round(calc.distance / 1000);
          r.kpis.driverMinutes = Math.round(calc.duration / 60);

          r.geometry = calc.geometry;

          //Update arrival times
          if (calc.legs) {
            var startMinutes = 0; //Should be route.startTime?
            for (var i = 0; i < calc.legs.length; i++) {
              var l = calc.legs[i];
              var s = r.stops[i + 1];
              if (s && s.kpi) s.kpi.driverMinutes = l.duration / 60;
            }
          }
          var conf = this.geoGetRouteSettingsLogicForTour(r.tourName);
          this.refreshKpisCalculation(conf, r.kpis);
        }
      });
    }
  }

  OptimizeSortOrderForRoute(r) {
    var places = r.stops.map((s) => s.place);
    if (places.length > 2)
      //exclude start and stop
      this.api.post("/api/geo/OptimizeSortOrder", places).then((res) => {
        console.log(res.data);
        var resStops = [];
        var changed = false;
        for (var i = 0; i < res.data.length; i++) {
          var newIdx = res.data[i];
          resStops[newIdx] = r.stops[i];
          if (newIdx != i) changed = true;
        }
        if (changed) {
          r.stops = resStops;
          this.routeSetDirty(r);
          r.geometry = null;
          this.refreshRoute(r);
        }
      });
  }

  MoveActionBetweenRoutes(action, fromRoute, toRoute) {
    // Om fromRoute = toRoute
    //      Gör inget
    // Ta bort a.booking ur fromRoute.bookings
    // Lägg till a.booking till toRoute.bookings
    // För alla actions a i fromRoute som innehåller action.booking.id
    //     pushAction(toRoute,a)
    //     ta bort action ur resp stop
    //     Om stop tomt, ta bort stop?? För finnas i en refresh att ta bort tomma stopp som inte är låsta
    // fromRoute=dirty
    // toRoute=dirty
    if (fromRoute == toRoute) return;
    var b = fromRoute.bookings.find((x) => x.id == action.booking.id);
    fromRoute.bookings = fromRoute.bookings.filter((x) => x.id !== b.id); //Remove current booking
    toRoute.bookings.push(b);
    b.tour = toRoute.tourName;
    b.resource = toRoute.resource;

    fromRoute.stops.map((s) => {
      s.actions
        .filter((a) => a.booking.id == b.id)
        .map((a) => this.pushAction(toRoute, s.place, a));
      s.actions = s.actions.filter((x) => x.booking.id != b.id);
    });
    this.routeRemoveEmptyStops(fromRoute);

    this.routeSetDirty(fromRoute);
    this.routeSetDirty(toRoute);
  }

  routeRemoveEmptyStops(route) {
    var initNoOfStops = route.stops.length;
    route.stops = route.stops.filter((s) => s.locked || s.actions.length > 0);
    if (route.stops.length != initNoOfStops) this.routeSetDirty(route);
  }

  MoveStopToPosition(r, s, idx) {
    const dummy = { id: -435785487 };
    // var s = destRoute.stops.find(x=> x.id == src.stop.id);
    //Must be between first and last stop
    if (idx <= 0) idx = 1;
    if (idx >= r.stops.length - 1) idx = r.stops.length - 1;
    r.stops.splice(idx, 0, dummy);
    r.stops = r.stops.filter((x) => x !== s);
    var newIdx = r.stops.findIndex((x) => x === dummy);
    r.stops[newIdx] = s;

    this.routeSetDirty(r);
  }

  setNameOnRoute(r, newName) {
    if (newName && newName != r.resource) {
      //Change name
      r.resource = newName;
      r.name = newName;
      r.bookings.map((b) => (b.resource = newName));
    }
  }

  isolateAction(action, stp, route) {
    console.log("isolateAction", action, route);
    //Validate action, stop and route
    if (!(action && route)) return;
    //TODO: Remove action from stop
    //TODO: Add new stop to route (after current stop)
    var idx = route.stops.findIndex((x) => x.stopId == stp.stopId);
    if (idx < 0) return;
    var s = route.stops[idx];

    //TODO: Clone stop s and add it to route.stops after idx
    var newStop = JSON.parse(JSON.stringify(s)); //Clone
    newStop.stopId = this.getUniqueId();
    //action.stopId = newStop.stopId; //Preserve stopId in action
    newStop.actions = [action]; //Only the action to isolate
    newStop.place = action.booking[action.type == "PU" ? "pickup" : "delivery"];
    newStop.text = `${newStop.place.street},${newStop.place.city}`;
    newStop.kpi = null; //Reset kpi
    //newStop.bookings = [action.booking]; //Set booking?

    s.actions = s.actions.filter((x) => x != action); //Remove action from current stop
    route.stops.splice(idx + 1, 0, newStop); //Add after current stop

    this.routeRemoveEmptyStops(route);
    this.routeSetDirty(route);
    this.refreshRoute(route);
  }

  MoveActionToStop(action, toStop, route) {
    //Move action to another stop in same route
    var s = route.stops.find(
      (x) =>
        x.actions.findIndex(
          (a) => a.booking.id == action.booking.id && a.type == action.type,
        ) >= 0,
    );
    if (s) {
      s.actions = s.actions.filter(
        (x) => !(x.booking.id == action.booking.id && x.type == action.type),
      );
      this.routeRemoveEmptyStops(route);
      toStop.actions.push(action);
      //this.pushAction(route, toStop.place, action);
      this.routeSetDirty(route);
      this.refreshRoute(route);
    }
  }

  getUniqueId() {
    if (this.uniqueId < 0) {
      //Get max id from plan
      var maxId = 0;
      if (this.plan) {
        this.plan.routes.map((r) => {
          if (r.id > maxId) maxId = r.id;
          r.stops.map((s) => {
            if (s.stopId > maxId) maxId = s.stopId;
          });
        });
        this.uniqueId = maxId + 1;
      } else {
        this.uniqueId = 1;
      }
    }

    return this.uniqueId++; //Simple unique id generator
  }
}
